import { loadStripe } from '@stripe/stripe-js/pure';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

var isElement = function isElement(item) {
  return item.nodeType === 1 && item.matches('*');
};
/**
 * Checks the `window` for `@olo/pay` and `Stripe` which can indicate whether
 * the library is being loaded via ESM.
 *
 * @returns True if Olo Pay and Stripe were loaded to the window object.
 */


var onWindow = function onWindow() {
  return Boolean('@olo/pay' in window && window.Stripe);
};

/**
 * Used for linking messages and errors to a feature.
 */
var Feature;

(function (Feature) {
  Feature["CreditCardElements"] = "CreditCardElements";
  Feature["DigitalWallets"] = "DigitalWallets";
  Feature["SingleLineCardElement"] = "SingleLineCardElement";
})(Feature || (Feature = {}));
/**
 * Logs a message to the console.
 */


var log = function log() {
  var _console;

  for (var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++) {
    data[_key] = arguments[_key];
  }

  return (_console = console).log.apply(_console, ['%c Olo Pay ', 'background: #25B3E2; color: #ffffff'].concat(data));
};
/**
 * Throws an error (stopping execution). Use sparingly if ever.
 */


var throwError = function throwError(message) {
  throw new Error("Olo Pay Error: " + message);
};
/**
 * Logs an error (continuing execution).
 */


var error = function error() {
  var _console2;

  for (var _len2 = arguments.length, data = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    data[_key2] = arguments[_key2];
  }

  (_console2 = console).error.apply(_console2, ['%c Olo Pay Error ', 'background: #FF2A53; color: #ffffff'].concat(data));
};

var message = {
  log: log,
  error: error,
  "throw": throwError
};

/**
 * Load Stripe JS only when the `loadStripe` function is called.
 * We want this by default—especially for Serve—which has many
 * brands not using Olo Pay. Using the common `loadStripe` import
 * will inject Stripe JS on app start and continually send data.
 */

var loadWithoutSideEffect = loadStripe;
var URL;

(function (URL) {
  URL["development"] = "https://static.olocdn.net/web-client/olo-pay/keys/dev.json";
  URL["production"] = "https://static.olocdn.net/web-client/olo-pay/keys/prod.json";
})(URL || (URL = {}));
/**
 * Sets up fraud signals and events by injecting a script into
 * the document `<head>` that loads supporting code. This will
 * also happen on instantiation of an Olo Pay feature, but can
 * be called early to improve fraud detection.
 */


function initializeOloPay() {
  return _initializeOloPay.apply(this, arguments);
}
/**
 * Loads Stripe instance and intercepts errors for a generic response.
 */


function _initializeOloPay() {
  _initializeOloPay = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (window.Stripe) {
              _context.next = 8;
              break;
            }

            _context.prev = 1;
            _context.next = 4;
            return import('@stripe/stripe-js');

          case 4:
            _context.next = 8;
            break;

          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](1);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 6]]);
  }));
  return _initializeOloPay.apply(this, arguments);
}

function setupStripe(_x, _x2) {
  return _setupStripe.apply(this, arguments);
}
/**
 * Fetches a publishable key from Olo CDN (dev.json or prod.json).
 */


function _setupStripe() {
  _setupStripe = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(feature, key) {
    var stripe, _window$Stripe;

    return runtime_1.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            stripe = null;
            _context2.prev = 1;

            if (onWindow()) {
              // Likely UMD
              stripe = (_window$Stripe = window.Stripe == null ? void 0 : window.Stripe(key)) != null ? _window$Stripe : null;
            }

            if (!(stripe === null)) {
              _context2.next = 7;
              break;
            }

            _context2.next = 6;
            return loadWithoutSideEffect(key);

          case 6:
            stripe = _context2.sent;

          case 7:
            if (!(stripe === null)) {
              _context2.next = 9;
              break;
            }

            throw new Error();

          case 9:
            return _context2.abrupt("return", stripe);

          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](1);
            message.error(feature + ": Please ensure you are passing a valid key");

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 12]]);
  }));
  return _setupStripe.apply(this, arguments);
}

function fetchKey(_x3) {
  return _fetchKey.apply(this, arguments);
}
/**
 * Sets up Stripe in development or production mode.
 */


function _fetchKey() {
  _fetchKey = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3(url) {
    var response, json;
    return runtime_1.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return fetch(url);

          case 3:
            response = _context3.sent;
            _context3.next = 6;
            return response.json();

          case 6:
            json = _context3.sent;
            return _context3.abrupt("return", json.key.trim() || '');

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", '');

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 10]]);
  }));
  return _fetchKey.apply(this, arguments);
}

function useStripe(_x4, _x5) {
  return _useStripe.apply(this, arguments);
}

function _useStripe() {
  _useStripe = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee4(feature, env) {
    var url, key, stripe;
    return runtime_1.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            url = /\bproduction\b/i.test(env) ? URL.production : URL.development;
            _context4.next = 3;
            return fetchKey(url);

          case 3:
            key = _context4.sent;
            _context4.next = 6;
            return setupStripe(feature, key);

          case 6:
            stripe = _context4.sent;

            if (stripe) {
              _context4.next = 10;
              break;
            }

            message.error(feature + ": Failed to access Olo Pay");
            return _context4.abrupt("return");

          case 10:
            return _context4.abrupt("return", stripe);

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _useStripe.apply(this, arguments);
}

var defaultBase = {
  color: 'inherit',
  backgroundColor: 'inherit',
  fontFamily: 'inherit',
  fontSize: '1.8rem',
  fontSmoothing: 'inherit',
  fontStyle: 'inherit',
  fontVariant: 'inherit',
  fontWeight: 'inherit',
  iconColor: '#25B3E2',
  lineHeight: 'inherit',
  letterSpacing: 'inherit',
  textAlign: 'inherit',
  textDecoration: 'inherit',
  textShadow: 'inherit',
  textTransform: 'inherit'
};
var defaultPseudos = {
  ':hover': defaultBase,
  ':focus': defaultBase,
  '::placeholder': defaultBase,
  '::selection': defaultBase,
  ':-webkit-autofill': defaultBase,
  ':disabled': defaultBase,
  '::-ms-clear': /*#__PURE__*/_extends({}, defaultBase, {
    display: 'string'
  })
};
var defaultStyles = /*#__PURE__*/_extends({}, defaultBase, defaultPseudos);
var defaultStyleObject = {
  base: /*#__PURE__*/_extends({}, defaultStyles),
  complete: /*#__PURE__*/_extends({}, defaultStyles),
  empty: /*#__PURE__*/_extends({}, defaultStyles),
  invalid: /*#__PURE__*/_extends({}, defaultStyles)
};

var CreditCardElements = /*#__PURE__*/function () {
  // ===========================================================================
  // Constructor
  // ===========================================================================
  function CreditCardElements(environment) {
    if (environment === void 0) {
      environment = 'development';
    }

    this.environment = environment;
    this.defaultMountTargets = {
      number: '[data-olo-pay-card-number]',
      expiry: '[data-olo-pay-card-expiry]',
      cvc: '[data-olo-pay-card-cvc]'
    };
    this.defaultOptions = {
      classes: {
        base: 'olo-pay',
        complete: 'olo-pay--complete',
        empty: 'olo-pay--empty',
        focus: 'olo-pay--focus',
        invalid: 'olo-pay--invalid',
        webkitAutofill: 'olo-pay--webkit-autofill'
      }
    };
    this.defaultPlaceholders = {
      number: 'Card number',
      expiry: 'Card expiry',
      cvc: 'Card CVC'
    };
  } // ===========================================================================
  // Methods
  // ===========================================================================

  /**
   * Appends a credit card field to a passed element or selector of a DOM element.
   *
   * Defaults:
   * - Credit card number: `data-olo-pay-card-number`
   * - Credit card expiration date: `data-olo-pay-card-expiry`
   * - Credit card CVC: `data-olo-pay-card-cvc`
   *
   * Note: all three fields are required for a valid credit card submission.
   *
   * @param cardOptions Options object containing information for:
   * `cardElementOptions`, `elementsOptions`, `mountTargets`, and `placeholders`.
   */


  var _proto = CreditCardElements.prototype;

  _proto.create =
  /*#__PURE__*/
  function () {
    var _create = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(cardOptions) {
      var elements, options, placeholders, cardNumber, cardExpiry, cardCvc, targets;
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return useStripe(Feature.CreditCardElements, this.environment);

            case 2:
              this.stripe = _context.sent;

              if (this.stripe) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return");

            case 5:
              elements = this.stripe.elements((cardOptions == null ? void 0 : cardOptions.elementsOptions) || {});
              options = _extends({}, this.defaultOptions, cardOptions == null ? void 0 : cardOptions.cardElementOptions);
              placeholders = (cardOptions == null ? void 0 : cardOptions.placeholders) || this.defaultPlaceholders; // Create the elements

              cardNumber = elements.create('cardNumber', _extends({}, options, {
                placeholder: placeholders.number
              }));
              cardExpiry = elements.create('cardExpiry', _extends({}, options, {
                placeholder: placeholders.expiry
              }));
              cardCvc = elements.create('cardCvc', _extends({}, options, {
                placeholder: placeholders.cvc
              })); // Mount the elements to their DOM targets

              targets = (cardOptions == null ? void 0 : cardOptions.mountTargets) || this.defaultMountTargets;
              _context.prev = 12;
              cardNumber.mount(targets.number);
              cardExpiry.mount(targets.expiry);
              cardCvc.mount(targets.cvc);
              _context.next = 22;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](12);
              message.error(Feature.CreditCardElements + ":\n        Unable to mount Olo Pay elements to their DOM targets\n        Please ensure valid selectors or elements are passed to `create`");
              return _context.abrupt("return");

            case 22:
              // Store references to mounted elements
              this.cardNumber = elements.getElement('cardNumber') || undefined;
              this.cardExpiry = elements.getElement('cardExpiry') || undefined;
              this.cardCvc = elements.getElement('cardCvc') || undefined;

              if (this.cardNumber) {
                _context.next = 27;
                break;
              }

              return _context.abrupt("return", message.error('Number input not mounted properly'));

            case 27:
              if (this.cardExpiry) {
                _context.next = 29;
                break;
              }

              return _context.abrupt("return", message.error('Expiry input not mounted properly'));

            case 29:
              if (this.cardCvc) {
                _context.next = 31;
                break;
              }

              return _context.abrupt("return", message.error('CVC input not mounted properly'));

            case 31:
              this.elements = [this.cardNumber, this.cardExpiry, this.cardCvc] || [];

            case 32:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[12, 18]]);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }()
  /**
   * Creates a payment method using card details on the form and
   * billing details (if passed).
   *
   * @param billingDetails Address, email, name, and phone.
   */
  ;

  _proto.createPaymentMethod =
  /*#__PURE__*/
  function () {
    var _createPaymentMethod = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(billingDetails) {
      var paymentMethod;
      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!this.stripe || !this.cardNumber)) {
                _context2.next = 3;
                break;
              }

              message.error("Failed to create a payment method due to missing: " + (this.stripe ? 'cardNumber element' : 'Olo Pay connection. Call `create` first'));
              return _context2.abrupt("return");

            case 3:
              _context2.next = 5;
              return this.stripe.createPaymentMethod({
                type: 'card',
                card: this.cardNumber,
                billing_details: billingDetails
              });

            case 5:
              paymentMethod = _context2.sent;
              return _context2.abrupt("return", paymentMethod);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function createPaymentMethod(_x2) {
      return _createPaymentMethod.apply(this, arguments);
    }

    return createPaymentMethod;
  }()
  /**
   * Applies a style object to the credit card elements.
   *
   * @param style Style object.
   */
  ;

  _proto.applyStyles = function applyStyles(style) {
    var _this$cardNumber, _this$cardExpiry, _this$cardCvc;

    if (style === void 0) {
      style = defaultStyleObject;
    }

    (_this$cardNumber = this.cardNumber) == null ? void 0 : _this$cardNumber.update({
      style: style
    });
    (_this$cardExpiry = this.cardExpiry) == null ? void 0 : _this$cardExpiry.update({
      style: style
    });
    (_this$cardCvc = this.cardCvc) == null ? void 0 : _this$cardCvc.update({
      style: style
    });
  }
  /**
   * Clear all credit card field values.
   */
  ;

  _proto.clear = function clear() {
    var _this$cardNumber2, _this$cardExpiry2, _this$cardCvc2;

    (_this$cardNumber2 = this.cardNumber) == null ? void 0 : _this$cardNumber2.clear();
    (_this$cardExpiry2 = this.cardExpiry) == null ? void 0 : _this$cardExpiry2.clear();
    (_this$cardCvc2 = this.cardCvc) == null ? void 0 : _this$cardCvc2.clear();
  }
  /**
   * Removes credit card elements from the DOM and destroys them.
   * A destroyed element can not be re-activated or re-mounted to the DOM.
   */
  ;

  _proto.destroy = function destroy() {
    var _this$cardNumber3, _this$cardExpiry3, _this$cardCvc3;

    (_this$cardNumber3 = this.cardNumber) == null ? void 0 : _this$cardNumber3.destroy();
    (_this$cardExpiry3 = this.cardExpiry) == null ? void 0 : _this$cardExpiry3.destroy();
    (_this$cardCvc3 = this.cardCvc) == null ? void 0 : _this$cardCvc3.destroy();
    this.elements = undefined;
  }
  /**
   * Mounts credit card elements to the DOM.
   * Call `unmount` to remove them from the DOM.
   *
   * @param mountTargets Object containing selector or element targets.
   */
  ;

  _proto.mount = function mount(mountTargets) {
    var _this$cardNumber4, _this$cardExpiry4, _this$cardCvc4;

    if (mountTargets === void 0) {
      mountTargets = this.defaultMountTargets;
    }

    (_this$cardNumber4 = this.cardNumber) == null ? void 0 : _this$cardNumber4.mount(mountTargets.number);
    (_this$cardExpiry4 = this.cardExpiry) == null ? void 0 : _this$cardExpiry4.mount(mountTargets.expiry);
    (_this$cardCvc4 = this.cardCvc) == null ? void 0 : _this$cardCvc4.mount(mountTargets.cvc);
  }
  /**
   * Unmounts credit card elements from the DOM.
   * Call `mount` to re-attach them to the DOM.
   */
  ;

  _proto.unmount = function unmount() {
    var _this$cardNumber5, _this$cardExpiry5, _this$cardCvc5;

    (_this$cardNumber5 = this.cardNumber) == null ? void 0 : _this$cardNumber5.unmount();
    (_this$cardExpiry5 = this.cardExpiry) == null ? void 0 : _this$cardExpiry5.unmount();
    (_this$cardCvc5 = this.cardCvc) == null ? void 0 : _this$cardCvc5.unmount();
  }
  /**
   * Updates the options the credit card elements were initialized with.
   * Updates are merged into the existing configuration.
   *
   * @param newOptions
   */
  ;

  _proto.update = function update(newOptions) {
    var _this$cardNumber6, _this$cardExpiry6, _this$cardCvc6;

    if (newOptions === void 0) {
      newOptions = this.defaultOptions;
    }

    (_this$cardNumber6 = this.cardNumber) == null ? void 0 : _this$cardNumber6.update(newOptions);
    (_this$cardExpiry6 = this.cardExpiry) == null ? void 0 : _this$cardExpiry6.update(newOptions);
    (_this$cardCvc6 = this.cardCvc) == null ? void 0 : _this$cardCvc6.update(newOptions);
  };

  return CreditCardElements;
}();

function find(target) {
  if (isElement(target)) {
    var element = target;
    return element.isConnected ? element : null;
  }

  try {
    return document.querySelector(target);
  } catch (error) {
    message.error("No element marked with " + target + " found");
    return null;
  }
}

var TEST_PAYMENT_METHOD = {
  paymentMethod: {
    id: 'pm_visa',
    object: 'payment_method',
    billing_details: {
      address: {
        city: 'New York',
        country: 'US',
        line1: 'One World Trade Center',
        line2: null,
        postal_code: '10006',
        state: 'NY'
      },
      email: 'olopaytest@test.com',
      name: 'Test Mode',
      phone: '4444444444'
    },
    card: {
      brand: 'visa',
      checks: {
        address_line1_check: null,
        address_postal_code_check: null,
        cvc_check: null
      },
      country: 'US',
      exp_month: 12,
      exp_year: 2031,
      funding: 'credit',
      generated_from: null,
      last4: '1234',
      networks: {
        available: ['visa'],
        preferred: null
      },
      three_d_secure_usage: {
        supported: true
      },
      wallet: {
        dynamic_last4: '1234',
        google_pay: {},
        type: 'google_pay'
      }
    },
    created: 1628283848,
    customer: null,
    livemode: false,
    type: 'card'
  }
};

var DigitalWallets = /*#__PURE__*/function () {
  // ===========================================================================
  // Constructor
  // ===========================================================================
  function DigitalWallets(environment) {
    if (environment === void 0) {
      environment = 'development';
    }

    this.environment = environment;
    this.defaultPaymentRequestOptions = {
      currency: 'usd',
      total: {
        label: 'test',
        amount: 0
      },
      requestPayerName: true
    }; // Indicates whether a digital wallets payment can be made

    this.canMakePayment = null;
  } // ===========================================================================
  // Methods
  // ===========================================================================

  /**
   * Initializes a digital wallet's payment request so that a `DigitalWallets` button can be created.
   *
   * @param options Digital wallets options containing style and payment request options.
   * @example
   * HTML
   * <div data-olo-pay-payment-button></div>
   *
   * @example
   * JS
   * const digitalWallets = new DigitalWallets();
   * await digitalWallets.initialize(options);
   *
   * // Will return an object of { applePay: false, googlePay: false }
   * const canMakePayment = digitalWallets.canMakePayment;
   */


  var _proto = DigitalWallets.prototype;

  _proto.initialize =
  /*#__PURE__*/
  function () {
    var _initialize = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(options) {
      var _this$digitalWalletsO, currency, total, displayItems, shippingOptions, paymentRequest;

      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this.stripe) {
                _context.next = 4;
                break;
              }

              _context.next = 3;
              return useStripe(Feature.DigitalWallets, this.environment);

            case 3:
              this.stripe = _context.sent;

            case 4:
              if (this.stripe) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return");

            case 6:
              if (options) {
                _context.next = 9;
                break;
              }

              message.error('No digital wallets options provided');
              return _context.abrupt("return");

            case 9:
              this.digitalWalletsOptions = options; // If a default paymentRequest already exists, update it
              // Also, only update the payment request options if the payment sheet is not showing (in the event of a re-render or timing issue)

              if (!(this.paymentRequest && !this.paymentRequest.isShowing())) {
                _context.next = 17;
                break;
              }

              _this$digitalWalletsO = this.digitalWalletsOptions.options, currency = _this$digitalWalletsO.currency, total = _this$digitalWalletsO.total, displayItems = _this$digitalWalletsO.displayItems, shippingOptions = _this$digitalWalletsO.shippingOptions;
              this.updatePaymentDetails({
                currency: currency,
                total: total,
                displayItems: displayItems,
                shippingOptions: shippingOptions
              });
              _context.next = 15;
              return this.paymentRequest.canMakePayment();

            case 15:
              this.canMakePayment = _context.sent;
              return _context.abrupt("return");

            case 17:
              // Initialize the payment request with provided options
              paymentRequest = this.stripe.paymentRequest(this.digitalWalletsOptions.options);
              _context.next = 20;
              return paymentRequest.canMakePayment();

            case 20:
              this.canMakePayment = _context.sent;
              this.paymentRequest = paymentRequest;

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function initialize(_x) {
      return _initialize.apply(this, arguments);
    }

    return initialize;
  }()
  /**
   * Appends a `Stripe Elements` Payment Request Button to an element marked with a matching `data-olo-pay-payment-button` attribute.
   * @param callback Function to execute after the payment is submitted in the digital wallets payment sheet.
   *
   * @example
   * HTML
   * <div data-olo-pay-payment-button></div>
   *
   * @example
   * JS
   * const digitalWallets = new DigitalWallets();
   * await digitalWallets.initialize(options);
   * digitalWallets.mountButton(callback);
   */
  ;

  _proto.mountButton = function mountButton(callback, target) {
    var _this = this;

    if (!this.digitalWalletsOptions || !this.paymentRequest || !this.stripe) {
      message.error('Digital Wallets not initialized properly.');
      return;
    }

    var paymentRequest = this.paymentRequest; // Intercept the 'paymentmethod' request. Return the payment method object to client.

    paymentRequest.on('paymentmethod', function (ev) {
      _this.paymentEvent = ev;
      callback(ev.paymentMethod);
    }); // Grab the intended Payment Request Button element.
    // If a button doesn't exist, user may be implementing their own custom button.

    var buttonSlot = find(target || '[data-olo-pay-payment-button]'); // If the user is using their own custom button, no more initialization is needed

    if (!buttonSlot) return;
    var _this$digitalWalletsO2 = this.digitalWalletsOptions,
        classes = _this$digitalWalletsO2.classes,
        style = _this$digitalWalletsO2.style;
    var elements = this.stripe.elements();
    var button = elements.create('paymentRequestButton', _extends({
      paymentRequest: paymentRequest
    }, classes ? classes : {}, style ? {
      style: {
        paymentRequestButton: _extends({}, style)
      }
    } : {})); // Determine if Apple Pay or Google Pay are applicable.
    // If either Apple Pay or Google Pay is available, render the button.
    // Otherwise, hide the slot reserved for the payment request button

    if (buttonSlot && this.canMakePayment) {
      button.mount('[data-olo-pay-payment-button]');
    } else {
      buttonSlot.style.display = 'none';
    } // In test mode, intercept the button's click event and return a test payment method


    if (this.environment === 'test') {
      message.log('Digital Wallets is running in test mode.');
      button.on('click', function (event) {
        event.preventDefault();
        window.PaymentRequest = paymentRequest;
        window.PaymentRequest.emit('paymentmethod', TEST_PAYMENT_METHOD);
      });
    }

    this.paymentButton = button;
  }
  /**
   * Initiates a payment by showing the Google Pay or Apple Pay payment sheet.
   * This can be triggered when using a custom payment button,
   * or in scenarios where preventing the default 'click' event behavior is necessary
   * (i.e. proper form validation prior to initiating the payment).
   *
   * @example
   * const digitalWallets = new DigitalWallets();
   * await digitalWallets.initialize(options);
   *
   * digitalWallets.paymentButton.on('click', (event) => {
   *  event.preventDefault();
   *
   *  // Launch payment sheet if form is valid
   *  if (formIsValid) {
   *    dw.initiatePayment();
   *  }
   * });
   */
  ;

  _proto.initiatePayment = function initiatePayment() {
    if (this.canMakePayment) {
      var _this$paymentRequest;

      (_this$paymentRequest = this.paymentRequest) == null ? void 0 : _this$paymentRequest.show();
    }
  }
  /**
   * Determines which digital wallets are available in the current browser context.
   *
   * @example
   * const canRenderButton = await digitalWallets.canRenderButton();
   * if (canRenderButton && (canRenderButton.applePay || canRenderButton.googlePay)) {
   *  // Do something
   * }
   */
  ;

  _proto.canRenderButton =
  /*#__PURE__*/
  function () {
    var _canRenderButton = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(country) {
      var _this$stripe;

      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (country === void 0) {
                country = 'US';
              }

              _context2.next = 3;
              return useStripe(Feature.DigitalWallets, this.environment);

            case 3:
              this.stripe = _context2.sent;

              if (this.stripe) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt("return", null);

            case 6:
              this.paymentRequest = (_this$stripe = this.stripe) == null ? void 0 : _this$stripe.paymentRequest(_extends({}, this.defaultPaymentRequestOptions, {
                country: country
              }));
              _context2.next = 9;
              return this.paymentRequest.canMakePayment();

            case 9:
              this.canMakePayment = _context2.sent;
              return _context2.abrupt("return", this.canMakePayment);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function canRenderButton(_x2) {
      return _canRenderButton.apply(this, arguments);
    }

    return canRenderButton;
  }()
  /**
   * Updates payment details to be reflected on the payment sheet
   */
  ;

  _proto.updatePaymentDetails = function updatePaymentDetails(options) {
    if (!this.paymentRequest) return;
    this.paymentRequest.update(options);
  }
  /**
   * Completes the pending payment event to close the active payment sheet
   */
  ;

  _proto.completePaymentEvent = function completePaymentEvent() {
    var _this$paymentEvent;

    (_this$paymentEvent = this.paymentEvent) == null ? void 0 : _this$paymentEvent.complete('success');
  }
  /**
   * Fails the pending payment event
   */
  ;

  _proto.failPaymentEvent = function failPaymentEvent() {
    var _this$paymentEvent2;

    (_this$paymentEvent2 = this.paymentEvent) == null ? void 0 : _this$paymentEvent2.complete('fail');
  }
  /**
   * Removes the element from the DOM and destroys it.
   * A destroyed element can not be re-activated or re-mounted to the DOM.
   */
  ;

  _proto.destroy = function destroy() {
    var _this$paymentButton;

    (_this$paymentButton = this.paymentButton) == null ? void 0 : _this$paymentButton.destroy();
  }
  /**
   * Unmounts the element from the DOM. Call element.mount to re-attach it to the DOM.
   */
  ;

  _proto.unmount = function unmount() {
    var _this$paymentButton2;

    (_this$paymentButton2 = this.paymentButton) == null ? void 0 : _this$paymentButton2.unmount();
  };

  return DigitalWallets;
}();

var SingleLineCardElement = /*#__PURE__*/function () {
  // ===========================================================================
  // Constructor
  // ===========================================================================
  function SingleLineCardElement(environment) {
    if (environment === void 0) {
      environment = 'development';
    }

    this.environment = environment;
    this.defaultMountTarget = '[data-olo-pay-card-single-line]'; // TODO: Move this

    this.defaultOptions = {
      classes: {
        base: 'olo-pay',
        complete: 'olo-pay--complete',
        empty: 'olo-pay--empty',
        focus: 'olo-pay--focus',
        invalid: 'olo-pay--invalid',
        webkitAutofill: 'olo-pay--webkit-autofill'
      }
    };
  } // ===========================================================================
  // Methods
  // ===========================================================================

  /**
   * Appends a single-line credit card field to a passed element or selector of a DOM element.
   *
   * If no value for `mountTarget` is passed in, the default mount target is `data-olo-pay-card-single-line`.
   *
   * @param cardOptions Options object containing information for:
   * `cardElementOptions`, `elementsOptions`, `mountTarget`.
   */


  var _proto = SingleLineCardElement.prototype;

  _proto.create =
  /*#__PURE__*/
  function () {
    var _create = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(cardOptions) {
      var elements, options, card, target;
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return useStripe(Feature.SingleLineCardElement, this.environment);

            case 2:
              this.stripe = _context.sent;

              if (this.stripe) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return");

            case 5:
              elements = this.stripe.elements((cardOptions == null ? void 0 : cardOptions.elementsOptions) || {});
              options = _extends({}, this.defaultOptions, cardOptions == null ? void 0 : cardOptions.cardElementOptions);
              card = elements.create('card', _extends({}, options)); // Mount the element to its DOM target

              target = (cardOptions == null ? void 0 : cardOptions.mountTarget) || this.defaultMountTarget;
              _context.prev = 9;
              card.mount(target);
              _context.next = 17;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](9);
              message.error(Feature.SingleLineCardElement + ":\n          Unable to mount Olo Pay single-line card element to its DOM target\n          Please ensure valid selectors or elements are passed to `create`");
              return _context.abrupt("return");

            case 17:
              // Store reference to mounted element
              this.element = elements.getElement('card') || undefined;

              if (this.element) {
                _context.next = 20;
                break;
              }

              return _context.abrupt("return", message.error('Single-line card element not mounted properly'));

            case 20:
              return _context.abrupt("return");

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[9, 13]]);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }()
  /**
   * Creates a payment method using card details on the form and
   * billing details (if passed).
   *
   * @param billingDetails Address, email, name, and phone.
   */
  ;

  _proto.createPaymentMethod =
  /*#__PURE__*/
  function () {
    var _createPaymentMethod = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(billingDetails) {
      var paymentMethod;
      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!this.stripe || !this.element)) {
                _context2.next = 3;
                break;
              }

              message.error("Failed to create a payment method due to missing: " + (this.stripe ? 'singleLineCard element' : 'Olo Pay connection. Call `create` first'));
              return _context2.abrupt("return");

            case 3:
              _context2.next = 5;
              return this.stripe.createPaymentMethod({
                type: 'card',
                card: this.element,
                billing_details: billingDetails
              });

            case 5:
              paymentMethod = _context2.sent;
              return _context2.abrupt("return", paymentMethod);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function createPaymentMethod(_x2) {
      return _createPaymentMethod.apply(this, arguments);
    }

    return createPaymentMethod;
  }()
  /**
   * Applies a style object to the element.
   *
   * @param style Style object.
   */
  ;

  _proto.applyStyles = function applyStyles(style) {
    var _this$element;

    if (style === void 0) {
      style = defaultStyleObject;
    }

    (_this$element = this.element) == null ? void 0 : _this$element.update({
      style: style
    });
  }
  /**
   * Clear all credit card field values.
   */
  ;

  _proto.clear = function clear() {
    var _this$element2;

    (_this$element2 = this.element) == null ? void 0 : _this$element2.clear();
  }
  /**
   * Removes the element from the DOM and destroys it.
   * A destroyed element can not be re-activated or re-mounted to the DOM.
   */
  ;

  _proto.destroy = function destroy() {
    var _this$element3;

    (_this$element3 = this.element) == null ? void 0 : _this$element3.destroy();
    this.element = undefined;
  }
  /**
   * Mounts the element to the DOM.
   * Call `unmount` to remove it from the DOM.
   *
   * @param mountTarget Object containing selector or element target.
   */
  ;

  _proto.mount = function mount(mountTarget) {
    var _this$element4;

    if (mountTarget === void 0) {
      mountTarget = this.defaultMountTarget;
    }

    (_this$element4 = this.element) == null ? void 0 : _this$element4.mount(mountTarget);
  }
  /**
   * Unmounts the element from the DOM.
   * Call `mount` to re-attach it to the DOM.
   */
  ;

  _proto.unmount = function unmount() {
    var _this$element5;

    (_this$element5 = this.element) == null ? void 0 : _this$element5.unmount();
  }
  /**
   * Updates the options that the element was initialized with.
   * Updates are merged into the existing configuration.
   *
   * @param newOptions
   */
  ;

  _proto.update = function update(newOptions) {
    var _this$element6;

    if (newOptions === void 0) {
      newOptions = this.defaultOptions;
    }

    (_this$element6 = this.element) == null ? void 0 : _this$element6.update(newOptions);
  };

  return SingleLineCardElement;
}();

export { CreditCardElements, DigitalWallets, SingleLineCardElement, initializeOloPay };
//# sourceMappingURL=olo-pay.esm.js.map
